/**
 *
 */
(function(window, undefined) {
    'use strict';
    var UserSrvc = function() {
        this.user;
        this.abilitazioni = [];
        this.configurazioni = {};
        this.abilitazioniPronte;
        this.labelsPronte;
        this.numeroProposteAcquistabili = 10000;
        this.promotoreAccettaRaccomandazione = '0';
        this.nascondiAbilitaConsulenza = false;
        this.selezioneIntestCoiFondo = 'N';
        this.inserimentoOrdiniVisibile = false;
        this.doppiaPrecisioneQuantita = false;
        this.iniziativaRaccomandazione = '';
        this.canaleOperativo = '';
        this.infoUploadDocumenti = '';
        this.mostraSoloVenditaOrdini = false;
        this.valutaPratica = false;
        this.modalitaEsposizioneESG = null;
        this.liquiditaAggiuntivaAttiva = null;
        // FIXME: rimuovere
        this.isBpa = false;

        var self = this;
        this.abilitato = function(funz) {
            if (!Array.isArray(self.abilitazioni) || !funz || !funz.trim) {
                return false;
            }
            funz = funz.trim();
            for (var i = 0; i < self.abilitazioni.length; i++) {
                var elem = self.abilitazioni[i];
                if (elem.codice === funz) {
                    return true;
                }
            }
            return false;
        };
    };

    UserSrvc.$inject = [];

    angular.module('cbl.finanza.mf').service('FinUserSrvc', UserSrvc);
})(window);



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/servicesUtilities/finUserSrvc.js
 ** module id = 27
 ** module chunks = 0 1 2
 **/